<template>
  <div class="page page-extras">
    <div class="page-title" v-if="page.header">
      <HTMLDisplay :content="page.header" />
    </div>
    <div class="playbook-page-content">
      <div class="playbook-page-column" v-for="(columnItems, index) in page.columns" :key="index">
        <PageColumnItem v-for="(item, indey) in columnItems" :key="indey" :item="item" :itemsCount="columnItems.length" :pageType="'Extras'"/>
      </div>
    </div>
    <div class="page-number-count" :class="{ 'right-page-number': pageId % 2 === 0 }">
      {{ pageId }}
    </div>
  </div>
</template>

<script>
import HTMLDisplay from "@/components/Projects/Playbooks/HTMLDisplay.vue"
import PageColumnItem from "@/components/Projects/Playbooks/PageColumnItem.vue"

export default {
  name: "Extras",

  computed: {

    products() {
      return this.page.products
    },

  },

  methods: {

  },

  props: {
    page: {
      type: Object
    },

    pageId: {
      type: Number
    }
  },

  components: {
    HTMLDisplay, PageColumnItem
  },

  data() {
    return {
      withDescription: false,
    };
  },
};
</script>

<style lang="scss">
.page-extras {
  .product-title-container {
    justify-content: center;
  }
}
</style>